import { isMoment, Moment } from 'moment';
import { useProcessAbsoluteDate } from './useProcessAbsoluteDate';
import { useProcessRelativeDate } from './useProcessRelativeDate';

export const useProcessDatePickerValue = () => {
  const processAbsoluteDate = useProcessAbsoluteDate();
  const processRelativeDate = useProcessRelativeDate();

  return (date: string | Moment) => {
    if (isMoment(date)) processAbsoluteDate(date);
    else processRelativeDate(date);
  };
};
